import * as Yup from 'yup'
import { i18n } from '@fs/zion-locale'

export const validationSchema = Yup.object().shape({
  additionalFacts: Yup.array().of(
    Yup.object().shape({
      id: Yup.string().required(),
      value: Yup.mixed()
        .nullable()
        .test(
          'validate-sex-code',
          i18n.t('FormValidation.notEmpty', 'Field cannot be empty.'),
          function validateSexField(value) {
            const { key } = this?.parent || {}

            if (key === 'SEX_CODE') {
              if (!value || (typeof value === 'object' && !value.primaryText && !value.key && !value.id)) {
                return true
              }
              if (!value?.standard) {
                return this.createError({
                  message: i18n.t('standardizedSexField.validation.warning', 'No Standard Selected'),
                })
              }
            }

            return true
          }
        ),
    })
  ),
})
